import { Component, Input, OnInit } from '@angular/core';
import { FantasyHistory, GameStatus } from '@fgb/core';

import * as _moment from 'moment';
const moment = _moment;

/** Indicates whether the current portal club team is playing in a FantasyGame*/
enum ClubPlayingStatus {
  /** Portal club not involved in the current game */
  None = 0,
  /** Portal club playing at home */
  Home = 1,
  /** Portal club playing away */
  Away = 2,
}

@Component({
  selector: 'fgb-fantasy-history-list-item',
  templateUrl: './fantasy-history-list-item.component.html',
  styleUrls: ['./fantasy-history-list-item.component.scss'],
})
export class FantasyHistoryListItemComponent implements OnInit {
  @Input() fantasyHistoryItem: FantasyHistory;

  gameDate: string;
  gameTime: string;
  isPending: boolean = false;

  constructor() { }

  ngOnInit() {
    this.gameDate = moment.utc(this.fantasyHistoryItem.GameDate).format('DD MMM');
    this.gameTime = moment.utc(this.fantasyHistoryItem.GameDate).format('HH:mm');

    this.isPending = this.fantasyHistoryItem.Status === GameStatus.Ready;
  }

  getOpponentTeamName(): string {
    //player is on home team
    if (this.fantasyHistoryItem.ClubPlayingStatus == ClubPlayingStatus.Home) {
      return this.fantasyHistoryItem.AwayTeamName + ' (A)';
    }
    // player is on away team
    else {
      return this.fantasyHistoryItem.HomeTeamName + ' (H)';
    }
  }
}
